module.exports = "/_next/static/images/4c8febf2d46a9aea0daeefdedefc9fee-credit-pre-ric.svg.webp";